<template>
  <div class="orders">
    <div class="row">
      <div class="col-sm-12">
        <b-card bg-variant="white">
          <LoadingSpinner v-if="isLoading" />
          <Alerts />

            {{ /* table controllerscontrollers */ }}
            <div>
              <div class="form-group form-inline pull-left mb-2">
                <b-button href size="sm" @click="sync()" class="vgt-left-btn">
                  <i class="fa fa-refresh" aria-hidden="true"></i>
                </b-button>&nbsp;
                <b-btn class="datepicker-button vgt-left-btn" size="sm" @click="$refs.datePicker.toggleCalendar()">Date</b-btn>
                <DateRangePicker
                  ref="datePicker"
                  @selected="onVGTDateRangeSelected"
                  i18n="EN"
                  :captions="{
                          'title': 'Choose Dates',
                          'ok_button': 'Apply'
                      }"
                  :presetRanges="datePresetRanges"
                ></DateRangePicker>&nbsp;
                <b-input-group size="sm">
                  <div class="input-group-prepend">
                    <div class="input-group-text vgt-left-btn">Marketplace</div>
                  </div>
                  <b-form-select
                    v-model="serverParams.marketType"
                    :options="marketplaceOptions"
                    @change="onVGTMarketplaceChange"
                  ></b-form-select>
                </b-input-group>
                &nbsp;
                <b-input-group size="sm">
                  <div class="input-group-prepend">
                    <div class="input-group-text vgt-left-btn">User</div>
                  </div>
                  <b-form-select
                    v-model="serverParams.printed_by"
                    :options="userOptions"
                    @change="onVGTPrintedByChange"
                  ></b-form-select>
                </b-input-group>
                &nbsp;
                <b-button
                  href
                  @click="cancelLabels"
                  class="vgt-left-btn vgt-red"
                  size="sm"
                  text-white
                >Void</b-button>&nbsp;
              </div>

              <div class="form-group form-inline pull-right mb-2">
                <b-input-group>
                  <b-input class="table-search border-right-0 border" v-model="searchkw" size="sm" placeholder="Search" @keypress.enter="onTableSearch"/>
                  <b-input-group-append>
                    <b-button
                      variant="outline-error"
                      class="border-left-0 border"
                      @click="onVGTClearSearch"
                    >
                      <i :class="['fa', 'fa-times', {'opacity-0': !searchkw}]"></i>
                    </b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-btn variant="success" @click="onTableSearch">
                      <i class="fa fa-search"></i>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
                &nbsp;
                <b-dropdown id="dropdown-1" text="Edit Columns" class="vgt-right-btn" size="sm">
                  <b-dropdown-form style="padding-left: 0.5rem">
                    <b-form-checkbox-group v-model="selectedColumns">
                      <b-form-checkbox v-for="col in columnSelection" :key="col.field" :value="col.field">
                        {{ col.label }}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                    <b-dropdown-item-button @click="onVGTColumnSelect">
                      <b-button size="sm" block class="vgt-right-btn">Apply</b-button>
                    </b-dropdown-item-button>
                  </b-dropdown-form>
                </b-dropdown>
                &nbsp;
                <!-- <b-button size="sm" @click="shippedExportOrders('csv')" class="vgt-right-btn">
                  Export Data
                  <span class="glyphicon glyphicon-download-alt"></span>
                </b-button> -->
                <b-button size="sm" @click="showModal()">
                  Export Data
                  <span class="glyphicon glyphicon-download-alt"></span>
              </b-button>
              </div>
            </div>
            {{ /* table controllerscontrollers */ }}

            <div class="clearfix"></div>

            <b-row class="justify-content-end">
              <b-col sm="auto" style="z-index: 999;">
                <b-input-group class="mb-2">
                  <div class="db-help import">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" dropup no-caret>
                      <template slot="button-content">
                        <b-img src="/images/icons/information.png" />
                      </template>
                      <b-dropdown-text class="mb-0 py-1 px-2" style="width: 304px">
                        <ul>
                          <li>Maximum selected records is {{ serverParams.perPage }}</li>
                          <li>Records selected has to be within the current table</li>
                        </ul>
                      </b-dropdown-text>
                    </b-dropdown>
                  </div>
                  <b-form-input
                    class="table-search border-right-0 border"
                    size="sm"
                    v-model="customRange"
                    placeholder="Custom Range (e.g. 1-5, 10)"
                    style="width: 200px;"
                    @keyup.enter="customSelectedRows"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="outline-error"
                      class="border-left-0 border"
                      @click="(e) => {
                        if(customRange) {
                          customRange = '';
                        }
                      }"
                    >
                      <i :class="['fa', 'fa-times', {'opacity-0': !customRange}]"></i>
                    </b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-btn variant="success" @click="customSelectedRows">Go</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>

            {{ /* VGT */ }}
            <vue-good-table
              ref="vgt"
              mode="remote"
              :columns="columns"
              :rows="rows"
              styleClass="vgt-table striped bordered condensed"
              max-height="70vh"
              :select-options="{ enabled: true, selectOnCheckboxOnly: true, selectionText: selected_text, clearSelectionText: 'Unselect All', selectionInfoClass: selection_class }"
              :search-options="{ enabled: true, externalQuery: searchTerm}"
              :pagination-options="{ enabled: true, mode: 'records', rowsPerPageLabel: 'Records per page', perPage: serverParams.perPage, perPageDropdown: [50, 100, 250], dropdownAllowAll: false }"
              :totalRows="totalRecords"
              :line-numbers="true"
              @on-search="onVGTSearch"
              @on-selected-rows-change="onVGTSelected"
              @on-row-dblclick="onVGTDoubleClick"
              @on-page-change="onVGTPageChange"
              @on-sort-change="onVGTSortChange"
              @on-column-filter="onVGTColumnFilter"
              @on-per-page-change="onVGTPerPageChange"
            >
              <div slot="emptystate"> N/A </div>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'id'" class="d-flex justify-content-center">
                  <button class="btn btn-primary btn-xs view mr-1" @click="showOrder(props.row.id)">View</button>
                  <button class="btn btn-primary btn-xs" @click="trackOrder(props.row.id)">Track</button>
                </span>
                <span v-else-if="props.column.field === 'marketplace' ">
                  <img
                    v-if="props.row.marketplace"
                    :src="props.row.marketplace.img"
                    :height="props.row.marketplace.height"
                    :width="props.row.marketplace.weight"
                    class="img-responsive"
                  />
                  <span v-else>.</span>
                </span>
                <span v-else-if="props.column.field === 'origin_address'">
                  <span v-if="props.row.prepaid_return">
                    Return Label
                  </span>
                  <span v-else>
                    {{ props.row.origin_address}} <br />
                  </span>
                </span>
                <span v-else-if="props.column.field === 'address'">
                  {{ props.row.address.address1}} <br />
                  {{ props.row.address.address2}} <br />
                  {{ props.row.address.address3}}
                </span>
                <span v-else-if="props.column.field === 'status'">
                  {{ $t(props.row.status)}}
                </span>
                <span v-else-if="props.column.field === 'name'">
                  <span v-if="props.row.name.name.trim()">
                    {{ props.row.name.name }} <br />
                  </span>
                  {{ props.row.name.company }}
                </span>
                <span v-else-if="props.column.field === 'confirmation'">
                  {{ getSignatureName(props.row) }}
                </span>
                <span v-else-if="props.column.field === 'tracking_id'">
                  <!-- <a :href="props.row.tracking_id.target" target="_blank" >{{ props.row.tracking_id.id }}</a> -->
                  <a href="javascript:void(0);" :id="`popover-${props.row.tracking_id.id}`">{{ props.row.tracking_id.id }}</a>
                  <b-popover :target="`popover-${props.row.tracking_id.id}`" triggers="click blur" placement="right">
                    <b-row class="flex-column">
                      <b-col>
                        <a :href="props.row.tracking_id.target" target="_blank" >Open Link</a>
                      </b-col>
                      <b-col>
                        <a href="javascript:void(0);" @click="copyTrackingID(props.row.tracking_id.id)" >Copy</a>
                      </b-col>
                    </b-row>
                  </b-popover>
                </span>
                <span v-else-if="['created_at'].includes(props.column.field)">
                  {{ props.row[props.column.field]|readableDate }}
                </span>
                <span v-else-if="['postmark_date'].includes(props.column.field)">
                  <div v-if="props.row.postmark_date">
                    {{ props.row.postmark_date|utcDate("MMM DD YYYY") }}
                  </div>
                  <div v-else>
                    {{ props.row.created_at|utcDate("MMM DD YYYY") }}
                  </div>
                </span>
                <span v-else-if="props.column.field === 'prepaid_return'">
                  <div v-if="props.row.prepaid_return">Yes</div>
                  <div v-else>No</div>
                </span>
                <span v-else-if="props.column.field === 'product_sku'">
                  {{ props.row.product_sku|truncate(75) }}
                </span>
                <!-- <span v-else-if="props.column.field === 'total_price'">
                  {{ format.price( props.row.rate + props.row.insurance_price + props.row.tracking_price ) }}
                </span> -->
                <span v-else-if="['declared_value', 'rate', 'insurance_price','total_price', 'tracking_price', 'surcharge'].includes(props.column.field)">
                  {{ format.price(props.row[props.column.field]) }}
                </span>
                <span v-else-if="props.column.field === 'total_weight'">
                  {{getWeight(props.row.total_weight).lb}}lb
                  {{getWeight(props.row.total_weight).oz}}oz
                </span>

                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>

            </vue-good-table>
            {{ /* VGT */ }}

        </b-card>
      </div>
    </div>

    <b-modal ref="modal_FN" hide-footer hide-header>
      <div style="background-color: #29286c; margin-top: -18px; position: absolute;left:0px; width:100% !important;">
        <div class="mx-auto" style="width: 100%" align="center">
          <h3 style="color: white; font-size: 18px !important;" class="mt-2">Export Data</h3>
        </div>
      </div>
      <div class="mt-4 row" style="font-size: 16px; line-height: 1.3em;">
        <div class="col-12">
          The current date range and active columns will be exported into a CSV file.
        </div>
      </div>
      <div class="row mt-3" style="font-size: 16px">
        <div class="form-group col-12 form-inline pull-left">
          <label for="inputUserFN">File Name:</label>
          <input style="width: 100%" id="inputUserFN" type="text" placeholder=""  required/>
          <span class="error" id="name-error" style="color: red; font-size: 15px;"></span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 ">
          <hr>
          <div style="margin-left: 43%">
            <button class="btn modalbtn modalbtn-cancel" @click="closeModal()">Cancel</button>
            <button class="btn modalbtn modalbtn-export" @click="confirmFN()">Export</button>
          </div>
        </div>
      </div>
    </b-modal>

    <div>
      <TrackingModal ref="trackingModal" :data="tracking" :orderType="orderType" v-if="tracking !== null" :key="tracking.id" @hide="onTrackingHide"></TrackingModal>
      <ShowOrder
        ref="viewOrderModal"
        :key="shown.id"
        :orderobj="shown"
        v-if="shown !== null"
        @hide="onShowOrderHide"
        @refresh="refresh"
      ></ShowOrder>
    </div>
  </div>
</template>
<style lang="scss">
.datepicker-button {
  &:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }

  & + .calendar-root {
    .input-date {
      display: none;
    }
    .calendar {
      left: 0px;
      top: 35px;
      height: auto;
      min-height: 300px;
    }
  }
}
.orders-table {
  tbody {
    td {
      text-align: center !important;
    }
  }
  tfoot {
    background-color: rgba(#1e88e5, 0.1);
  }
}
.modalbtn {
  border-radius: 15px !important;
  width: 90px !important; 
  height: 30px !important; 
  font-size: 15px !important; 
}
.modalbtn-cancel {
  outline-color:#1589FF;
  color: #1589FF !important;
  outline-style: solid;
}
.modalbtn-cancel:hover{
  background-color: #e7e7e7;
}
.modalbtn-export {
  background-color: #1589FF !important;
  color: white !important;
  margin-left: 10px;
}
.modalbtn-export:hover{
  background-color: #004488 !important;
}
.modal-body { overflow: hidden !important;}
.modal-md{
  top: 62px !important;
  width: 400px !important;
}
</style>

<script>
import LoadingSpinner from "../../components/LoadingSpinner";
import Alerts from "../../components/Alerts";
import DateRangePicker from "vue-rangedate-picker";
import ShowOrder from "./ShowShippedInModal";
import TrackingModal from "../../components/TrackingModal";
import moment from "moment";
import Cookies from 'js-cookie';
import hash from 'object-hash';
import { VueGoodTable } from 'vue-good-table';
import VGTMixin from './Mixins/VGTMixins';
import lStore from './Mixins/lStore';

export default {
  components: {
    VueGoodTable,
    LoadingSpinner,
    Alerts,
    ShowOrder,
    TrackingModal,
    DateRangePicker
  },
  mixins: [VGTMixin],
  // add props orderStatusId -> id & orderType -> name
  data(){
    return {
      tracking: null,
    }
  },
  async mounted() {
    const {status} = this.$route.query
    console.log("STATUS: ", status);
    if(status === "first-label"){
      console.log("first label");
      this.$router.push("/orders/new-shipment");
    }
    this.orderType = {
      id: 3,
      name: 'shipped',
    };
    // get saved in localstorage
    console.log('orderType', this.orderType);
    const cols = lStore.get(`${this.orderType.name}Columns`);
    if(cols){
      const { columns, selectedColumns } = cols;
      this.columns = columns;
      this.selectedColumns = selectedColumns;
    }
    const pP = lStore.get(`${this.orderType.name}PerPage`);
    if(pP){
      this.serverParams.perPage = pP;
    }

    await this.getUserPrintedBy()

    // await this.sync();
    await this.clearSessionAndFetch(this.orderType.name);
  },
  methods: {
    handleProceed() {
      if (this.pause) {
        Cookies.set(hash(this.messageBody), 1, { expires: 30 });
      }

      this.proceed(); // included in DialogMixin
    },
    refresh() {
      this.clearSessionAndFetch(this.orderType.name);
    },
    async cancelLabels() {
      const msg = `You are attempting to void this label. &nbsp;This action is irreversible. &nbsp;Per USPS regulations, voided labels takes 10-14 days to be credited back to your account. &nbsp;This shipment will be moved to the Voided Labels page.<hr />
      Please confirm that you are attempting to void ${this.serverParams.ids.length} labels?`;
      let dialog = null;
      try {
        dialog = await this.$dialog.confirm(msg, {
          view: 'void',
          customClass: 'void-dialog',
        });
        if(dialog){
          // this.isLoading = true;
          const response = await axios.post("cancelshipments", { employee_name: this.employee_name, ids: this.serverParams.ids });
          this.clearSessionAndFetch(this.orderType.name);
        }
      } catch (e){
        dialog.close();
        // not just canceling the dialog
        if(typeof(e) === 'object'){
          let message = e.response.data.message;
          if (e.response.data.errors) {
            message += ": ";
            message += Object.values(e.response.data.errors).join(" ");
          }
          this.$emit("alert", { message: message, type: "danger" });
        }
      } finally {
        this.serverParams.ids = [];
        await this.fetchOrders();
        // this.isLoading = false;
        if(dialog) dialog.close();
      }
    },

    closeModal(){ 
      this.$refs['modal_FN'].hide();
      $("#name-error").html("");
    },

    async showModal() {
      await this.$refs['modal_FN'].show();
      var DefaultFN = "Grandshipper";
      var dateNow = moment().format('MMDDYYYY-HHmmss');
      document.getElementById("inputUserFN").value = DefaultFN.concat(dateNow);
    },
    
    // CONFIRM EXPORT WITH FILE NAME
    async confirmFN(returns = false) {
      var userFN = await document.getElementById("inputUserFN").value;
      this.shippedExportOrders('csv', userFN);
    },

    async shippedExportOrders(exportType = 'csv', getFileName, returns = false,) {
      if (getFileName) {
        try {
          this.$refs['modal_FN'].hide();
          $("#name-error").html("");
          // const msg = 'The current date range and active columns will be exported into a CSV file';
          // if (!Cookies.get(hash(msg))) {
          //   let dialog = await this.$dialog.confirm(msg, { view: 'pausable' });
          //   dialog.close();
          // }

          const url = `/orders/export-vgt`;
          const headings = this.columns.map(column => {
            if (this.selectedColumns.includes(column.field) && column.field !== 'id') {
              return { [column.field]: column.label };
            }
          }).filter(v => !!v);
          const data = { headings, type: exportType, dateNow: moment().format('MMDDYYYY'), getFileName }

          const response = await axios.post(url, data, {
            params: Object.assign({}, { status: this.orderType.id }, this.serverParams)
          });
          // console.log('export response', response);
          window.open(response.data.url);
        } catch (e) {
          console.log(e);
        }
      }
      else
      {
        $("#name-error").html("This is required");
      }
    },

    async trackOrder(orderId) {
      try{
        this.isLoading = true;
        const response = await axios.get(`orders/${orderId}/track`);
        this.tracking = response.data;
        console.log('tracking', this.tracking);
        this.isLoading = false;
      } catch(e) {
        this.tracking = null;
        this.$emit("alert", {
          message: "Failed to track shipment. Was the package handed to USPS?",
          type: "danger",
        });
      }
    },
    async onTrackingHide(){
      console.log('hide tracking called');
      this.tracking = null;
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Orders/Shipped.vue